export default [
  {
    title: 'Name',
    type: 'text',
    data: '',
    initialValue: '',
    note_text: '',
    required: true,
    additional: '',
    dataIndex: 'name',
    order: 0,
  }, {
    title: 'Description',
    type: 'text',
    data: '',
    initialValue: '',
    note_text: '',
    additional: '',
    dataIndex: 'description',
    order: 1,
  },
]